export const getTypeColor = (type: string) => {
  const upperType = type.toUpperCase();
  switch (upperType) {
    case "MEDIA":
      return "#2563eb";
    case "BUTTON":
      return "#059669";
    case "GENERIC":
      return "#7c3aed";
    default:
      return "#6b7280";
  }
};

export const getTypeLabel = (type: string) => {
  const upperType = type.toUpperCase();
  switch (upperType) {
    case "MEDIA":
      return "Media";
    case "BUTTON":
      return "Button";
    case "GENERIC":
      return "Generic";
    default:
      return type;
  }
};

export const getStatusColor = (status: string) => {
  switch (status?.toUpperCase()) {
    case "ACTIVE":
      return "success";
    case "INACTIVE":
      return "default";
    case "APPROVED":
      return "green";
    case "PENDING":
      return "orange";
    case "REJECTED":
      return "red";
    default:
      return "default";
  }
};

export const getStatusLabel = (status: string) => {
  switch (status?.toUpperCase()) {
    case "ACTIVE":
      return "Hoạt động";
    case "INACTIVE":
      return "Tắt";
    default:
      return status;
  }
};

export const getScopeLabel = (scope: string) => {
  switch (scope?.toUpperCase()) {
    case "ADMIN":
      return "Hệ thống";
    case "USER":
      return "Cá nhân";
    default:
      return scope;
  }
};

export const getScopeColor = (scope: string) => {
  switch (scope?.toUpperCase()) {
    case "ADMIN":
      return "gold";
    case "USER":
      return "cyan";
    default:
      return "default";
  }
};